<template>
  <div v-if="visible" :style="backdropStyle">
    <div :style="bannerStyle">
      <div :style="contentStyle">
        <div :style="iconStyle">
          <svg :style="{ width: '20px', height: '20px' }" viewBox="0 0 24 24" fill="none" stroke="#8B6914" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <span :style="textStyle">{{ message }}</span>
        <button :style="closeBtnStyle" @mouseenter="closeHover = true" @mouseleave="closeHover = false" @click="closeToast" aria-label="Benachrichtigung schließen">✕</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiToast',
  props: {
    message: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visible: false,
      animating: false,
      closeHover: false
    }
  },
  mounted () {
    requestAnimationFrame(() => {
      this.visible = true
    })
    if (this.duration > 0) {
      setTimeout(this.closeToast, this.duration)
    }
  },
  computed: {
    backdropStyle () {
      return {
        position: 'fixed',
        bottom: '0',
        left: '0',
        right: '0',
        zIndex: '99999',
        display: 'flex',
        justifyContent: 'center',
        padding: '0 16px 24px 16px',
        pointerEvents: 'none',
        animation: 'toast-slide-up 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards'
      }
    },
    bannerStyle () {
      return {
        pointerEvents: 'auto',
        background: 'linear-gradient(135deg, #FDF6EC 0%, #F9E6DD 100%)',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(139, 105, 20, 0.08)',
        border: '1px solid rgba(139, 105, 20, 0.15)',
        padding: '16px 20px',
        maxWidth: '520px',
        width: '100%'
      }
    },
    contentStyle () {
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }
    },
    iconStyle () {
      return {
        flexShrink: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    textStyle () {
      return {
        flex: '1',
        fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#5C4A1E',
        fontWeight: '400',
        letterSpacing: '0.01em'
      }
    },
    closeBtnStyle () {
      return {
        flexShrink: '0',
        background: this.closeHover ? 'rgba(139, 105, 20, 0.1)' : 'none',
        border: 'none',
        color: '#8B6914',
        fontSize: '14px',
        cursor: 'pointer',
        width: '28px',
        height: '28px',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.2s ease',
        padding: '0',
        lineHeight: '1'
      }
    }
  },
  methods: {
    closeToast () {
      this.visible = false
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    }
  }
}
</script>

<style>
@keyframes toast-slide-up {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
